import { StyledButtons } from "./styles";
import { IToggleButtons } from "./types";

export const ToggleButtons = ({
  firstButtonName,
  firstButtonIcon,
  secondButtonName,
  secondButtonIcon,
  theme,
  value,
  setValue,
}: IToggleButtons) => {
  const classLight = "btn btn-outline-light";
  const classDark = "btn btn-outline-secondary to-primary";

  const firstSelected = {
    state: false,
    class: theme === "dark" ? classDark : classLight,
  };
  const secondSelected = {
    state: false,
    class: theme === "dark" ? classDark : classLight,
  };

  return (
    <div
      style={{ zIndex: 0 }}
      className="btn-group"
      role="group"
      aria-label="Basic checkbox toggle button group"
    >
      <StyledButtons
        onClick={() => setValue(firstButtonName)}
        className={
          value.find((elm) => elm === firstButtonName)
            ? firstSelected.class + " active"
            : firstSelected.class
        }
      >
        <i className={firstButtonIcon}></i>
        <span>{firstButtonName}</span>
      </StyledButtons>
      <StyledButtons
        onClick={() => setValue(secondButtonName)}
        className={
          value.find((elm) => elm === secondButtonName)
            ? secondSelected.class + " active"
            : secondSelected.class
        }
      >
        <i className={secondButtonIcon}></i>
        <span>{secondButtonName}</span>
      </StyledButtons>
    </div>
  );
};
